import React, { FunctionComponent } from 'react';

import { QuoteErrorPage as CommonQuoteErrorPage } from 'scenes/common/components/Error';
import { getErrorReason } from 'scenes/common/helpers/apiData';
import {
  ApiErrorReasonType,
  ErrorPageApiErrorReasonType,
  InsuranceName,
  InsuredItem,
} from 'scenes/common/types';
import { MotorFullPageProps } from 'scenes/motor/types';
import analytics from 'scenes/motor/analytics';

import { Embargo, Unknown, Declined } from './components';

const recoverableErrorOnDeclineType = new Map([
  [ApiErrorReasonType.InvalidCoverForSumInsured, ApiErrorReasonType.Declined],
]);

export const QuoteErrorPage: FunctionComponent<Pick<
  MotorFullPageProps,
  'onRestartQuote' | 'funnelState'
>> = ({ onRestartQuote, funnelState }) => {
  const { quoteNumber, type } = getErrorReason(
    funnelState.apiResponses.quoteDetails
  );

  return (
    <CommonQuoteErrorPage
      quoteNumber={quoteNumber}
      insuranceName={InsuranceName.Car}
      itemInsured={InsuredItem.Car}
      errorReasonType={
        (recoverableErrorOnDeclineType.get(type) ??
          type) as ErrorPageApiErrorReasonType
      }
      specificImages={{
        [ApiErrorReasonType.Declined]: () => <Declined />,
        [ApiErrorReasonType.Embargo]: () => <Embargo />,
        [ApiErrorReasonType.Unknown]: () => <Unknown />,
      }}
      onClickCallUs={() => analytics().callUs(funnelState)}
      onRestartQuote={onRestartQuote}
    />
  );
};

export default QuoteErrorPage;
